module.exports = __webpack_public_path__ + "assets/img/15.fw.d55d748c.png";